export default __webpack_public_path__ + "static/media/ppsh-41.3693da09.svg";